export default "__VITE_ASSET__DzZUq20$__"